import { defaultDayTags } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export function getValidDaysOfWeekBooleans(
  validDaysOfWeek: number[]
): boolean[] {
  return defaultDayTags.map((_, index) => validDaysOfWeek.includes(index + 1));
}
